import { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("khgb_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("khgb_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("khgb_user", JSON.stringify(r.data));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const r = await api.post("/auth/login", { username, password });
    localStorage.setItem("khgb_token", r.data.token);
    localStorage.setItem("khgb_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const changePassword = async (current_password, new_password) => {
    const r = await api.post("/auth/change-password", { current_password, new_password });
    localStorage.setItem("khgb_token", r.data.token);
    const next = { ...user, ...r.data.user, must_change_password: false };
    localStorage.setItem("khgb_user", JSON.stringify(next));
    setUser(next);
  };

  const logout = () => {
    localStorage.removeItem("khgb_token");
    localStorage.removeItem("khgb_user");
    setUser(null);
    window.location.href = "/giris";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, changePassword, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
